import { AufnahmePunktDocument, SubstratZeile } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";

export const karbonatEval: EvalFunc = (bp: any) => {
    const b = bp as AufnahmePunktDocument;
    if (!b.Substratfolge || b.Substratfolge.length === 0) return undefined;

    const index = b.Substratfolge.findIndex((s: SubstratZeile) => s.karbonatgehalt !== undefined && s.karbonatgehalt > 0);
    if (index < 0) return undefined;
    if (index === 0) return 0;
    return b.Substratfolge[index - 1].tiefe;
};

